'use client';

import { Provider, Viewport } from '@radix-ui/react-toast';
import { useState, type ReactNode } from 'react';

import { ToastStackContext } from './context';
import { Toast } from './Toast';
import styles from './Toast.module.scss';
import { createPortal } from 'react-dom';

//main
export type ToastStackProviderProps = {
  children: ReactNode;
};

export const ToastStackProvider = ({ children }: ToastStackProviderProps) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const showToast = (msg: string) => {
    setMessage(msg);
    setOpen(true);
  };

  return (
    <Provider>
      <ToastStackContext.Provider value={showToast}>
        {children}
      </ToastStackContext.Provider>
      <Toast
        duration={3000}
        title={message}
        open={open}
        onOpenChange={setOpen}
      />
      {createPortal(<Viewport className={styles.viewport} />, document.body)}
    </Provider>
  );
};
